import React from 'react';
import styles from './Footer.module.scss';
import reducer from './footer-reducer';
import Constant from '../../constants';
import logo from '../../images/logo.svg';
import { SiInstagram, SiFacebook, SiTwitter, SiYoutube } from 'react-icons/si';
import { AiOutlineCopyrightCircle } from 'react-icons/ai';

const Footer = () => {
  return (
    <main className={styles.footer}>
      <section className={styles.menu}>
        <article className={styles.menuItem}>Services</article>
        <article className={styles.menuItem}>Contact Us</article>
        <article className={styles.menuItem}>Reviews</article>
        <article className={styles.menuItem}>FAQ</article>
      </section>
      <section className={styles.socialMedia}>
        <SiInstagram className={styles.socialIcn} />
        <SiFacebook className={styles.socialIcn} />
        <SiTwitter className={styles.socialIcn} />
        <SiYoutube className={styles.socialIcn} />
      </section>
      <section className={styles.legal}>
        <article className={styles.copyright}>
          <AiOutlineCopyrightCircle className={styles.copyrightIcn} />
          <div className={styles.copyrightTxt}>
            <span className={styles.copyrightMsg}>
              {Constant.COPYRIGHT_MSG_I}
            </span>
            <span className={styles.copyrightMsg}>
              {Constant.COPYRIGHT_MSG_II}
            </span>
          </div>
        </article>
        <article>
          <p>
            Read our <a>Terms of Service</a> and <a>Privacy Policy</a>
          </p>
        </article>
      </section>
    </main>
  );
};

export default Footer;
